import { useMemo } from 'react';
import { FormName } from 'redux-form';
import { constants } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import BookableSeat from '../../containers/BookableSeatContainer';
import { getSeatCharacteristicLabels } from '../seatCharacteristics/utils/seatCharacteristicText';
import RowWrapper from './RowWrapper';
import Aisle from './Aisle';
import EmptySpace from './EmptySpace';
import Stairs from './Stairs';
import Toilet from './Toilet';
import UnavailableSeat from './UnavailableSeat';
import ExitArrow from './ExitArrow';
import { jsx as _jsx } from "react/jsx-runtime";
const renderRowItem = (activeSegment, carrier, isChild, isEmptyRow, isExitRow, isRyanairInTrip, onChange, t) => (item, key) => {
  switch (item === null || item === void 0 ? void 0 : item.type) {
    case 'TOILET':
      return /*#__PURE__*/_jsx(Toilet, {}, `rowItem-${key}`);
    case 'STAIRS':
      return /*#__PURE__*/_jsx(Stairs, {}, `rowItem-${key}`);
    case 'AISLE':
      return /*#__PURE__*/_jsx(Aisle, {
        row: item.row
      }, `rowItem-${key}`);
    case 'EXIT_ARROW':
      return /*#__PURE__*/_jsx(ExitArrow, {
        direction: key === 0 ? ExitArrow.Direction.LEFT : ExitArrow.Direction.RIGHT
      }, `rowItem-${key}`);
    case 'NORMAL':
      {
        const [seatTypeLabel] = useMemo(() => getSeatCharacteristicLabels(item.mainCharacteristic, !item.isBookable, t), [item.mainCharacteristic, item.isBookable]);
        if (!item.isBookable || isExitRow && isChild) {
          return /*#__PURE__*/_jsx(UnavailableSeat, {
            seatTypeLabel: seatTypeLabel
          }, `rowItem-${key}`);
        }
        return /*#__PURE__*/_jsx(FormName, {
          "data-testid": `rowItem-${key}`,
          children: _ref => {
            var _item$markup, _item$price;
            let {
              form
            } = _ref;
            return /*#__PURE__*/_jsx(BookableSeat, {
              activeSegment: activeSegment,
              carrier: carrier,
              column: item.column,
              form: form,
              isRyanairInTrip: isRyanairInTrip,
              mainCharacteristic: item.mainCharacteristic,
              markup: (_item$markup = item.markup) !== null && _item$markup !== void 0 ? _item$markup : null,
              onChange: onChange,
              price: (_item$price = item.price) !== null && _item$price !== void 0 ? _item$price : 0,
              row: item.row,
              seat: item.seat,
              seatTypeLabel: seatTypeLabel
            });
          }
        }, `rowItem-${key}`);
      }
    default:
      return /*#__PURE__*/_jsx(EmptySpace, {
        isExitRow: isEmptyRow
      }, `rowItem-${key}`);
  }
};
const RowContent = _ref2 => {
  let {
    activeSegment,
    carrier,
    isEmptyRow = false,
    isExitRow = false,
    isRyanairInTrip,
    onChange,
    seatTravelers = [],
    sellSeatMapSeats = []
  } = _ref2;
  const {
    t
  } = useTranslation();
  const isChild = seatTravelers === null || seatTravelers === void 0 ? void 0 : seatTravelers.some(seatTraveler => seatTraveler.ageType === constants.ageTypes.CHILD);
  return /*#__PURE__*/_jsx(RowWrapper, {
    children: sellSeatMapSeats === null || sellSeatMapSeats === void 0 ? void 0 : sellSeatMapSeats.map(renderRowItem(activeSegment, carrier, isChild, isEmptyRow, isExitRow, isRyanairInTrip, onChange, t))
  });
};
export default RowContent;
//# sourceMappingURL=RowContent.js.map